import { connect } from 'react-redux';

import { getRegionForTimeZone } from '../lib/timezone';
import { getSiteStatus, getUserLoginStatus } from '../lib/api';
import { setMaintenanceModeIsActive, setLoginStatus } from '../data/ui.redux';
import { saveFields } from '../data/client.redux';
import { setFlow } from '../data/flow.redux';
import Routes from './Routes';

export const setDefaultClientTimezone = client => {
  return dispatch => {
    if (client.timeZone) return;

    // https://caniuse.com/#search=Intl
    if (!window.Intl || !typeof window.Intl === 'object') return;

    const intlTimezone = window.Intl.DateTimeFormat().resolvedOptions().timeZone;
    const region = getRegionForTimeZone(intlTimezone);

    if (!region) return;

    dispatch(saveFields({ timeZone: region.name }));
  };
};

export const setDefaultClientCountryCode = client => {
  return dispatch => {
    // AdBlock will stop the library from loading entirely
    if (!window.geoip2) return null;

    return window.geoip2.country(res => {
      if (client.countryCode || !/CA|US/.test(res.country.iso_code)) return;

      const countryCode = res.country.iso_code;
      dispatch(saveFields({ countryCode }));
    });
  };
};

export const configureForMaintenanceMode = () => async dispatch => {
  try {
    const { maintenance } = await getSiteStatus();
    dispatch(setMaintenanceModeIsActive(maintenance));
    if (maintenance) {
      dispatch(setFlow('maintenance'));
    }
  } catch (err) {
    // If it couldn't be determined whether maintenance mode is active, set it to false
    dispatch(setMaintenanceModeIsActive(false));
  }
};

export const setUserLoginStatus = () => async dispatch => {
  const loginStatus = await getUserLoginStatus();
  dispatch(setLoginStatus(loginStatus));
};

const mapStateToProps = state => ({
  client: state.client,
  error: state.error,
});

const mapDispatchToProps = {
  configureForMaintenanceMode,
  setDefaultClientCountryCode,
  setDefaultClientTimezone,
  setUserLoginStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
